// components/auto-import/component
/* global DEBUG */

import template  from './component.jade'
import style from './style.scss'
import Store     from 'Store'
import parseUnixTime from 'lib/parseUnixTime'
import compareText from 'lib/sortArrays'
import AutoCarrierList  from 'components/auto-carrier-list/component'
import StationsList  from 'components/stations-list/component'
import SlotsAuto  from 'components/slots-auto/component'
import AutoList  from 'components/auto-list/component'
import DestinationsList  from 'components/destinations-list/component'
import datetimepicker from 'lib/datetimepicker'

let name = 'auto-import';
let url = '/api/AutoImport';

const store = new Store(name);

let skladList = ['ПИК', 'ВМКТ'];
let cnt_sizes = ['20', '40'];
let cnt_types = ['RF', 'ST', 'HC'];

export default {
    name: name,
    template: template({style: style}),

    data: () => ({
        name: name,
        url: url,
        autocarriers: null,
        autoLists: null,
        stations: null,
        destinations: null,
        slots: null,
        show: true,
        blockForm: false,
        errors: '',
        skladList:skladList,
        cnt_sizes:cnt_sizes,
        cnt_types:cnt_types,
        date_plan: null,
        disabled: false,
        exportCnt:null,
        order_phone:null,
        order_email:null,
        sklad: 'ПИК',
    }),

    ready() {
        datetimepicker(style);
        this.getautoCarrierList();
        this.getStationsList();
        this.getDestinationsList();
        this.$set('responsible_phone',store.$get('phone'));
        this.$set('email',store.$get('email'));
        this.$set('cnt_load', 'груженый');
        this.$set('sklad', 'ПИК');
        this.$set('buttonText', 'Сформировать');
        let date_plan = parseUnixTime(new Date().getTime() / 1000, 'dateVs');
        this.$set('date_oper', date_plan);
        this.getSlotsList(parseUnixTime(new Date().getTime() / 1000, 'dateTimeSOAP'), this.cnt_load);

    },
    methods: {
        getautoCarrierList(){
            let autoCarrierList = new Vue(AutoCarrierList);
            autoCarrierList.$emit('auto-carrier:auto-carrier-list', {
                name: 'auto-carrier-list',
            });
            this.$set('autoCarrierList', autoCarrierList.$data);
        },
        getStationsList(){
            let stationsList = new Vue(StationsList);
            stationsList.$emit('stations:stations-list', {
                name: 'stations-list',
            });
            this.$set('stationsList', stationsList.$data)
        },
        getDestinationsList(){
            let destinationsList = new Vue(DestinationsList);
            destinationsList.$emit('destinations:destinations-list', {
                name: 'destinations-list',
            });
            this.$set('destinationsList', destinationsList.$data)
        },
        getSlotsList(date, cntLoad){
            this.slots = null;
            let slotsAutoList = new Vue(SlotsAuto);
            slotsAutoList.$emit('slots-auto:slots-auto', {
                name: 'slots-auto',
                sklad: this.$get('sklad'),
                zavoz: false,
                cnt_load: cntLoad,
                date_oper: date,
            });
            this.$set('slotsAutoList', slotsAutoList.$data);
        },
        getAutoList(code){
            let autoList = new Vue(AutoList);
            autoList.$emit('auto-list:auto-list', {
                Kod_AutoCarrier: code,
            });
            this.$set('autoList', autoList.$data);
        },
        submit(e) {
            e.preventDefault();
            let formData = new FormData();
            let data = $(this.$$.form).serializeArray();
            let errors = '';
            if (!this.$get('slot') || !(this.$get('slot').length)) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Временной слот"';
            $.each(data, function (i, field) {
                formData.append(field.name, field.value);
                if (field.name === 'Transport' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Транспорт"';
                if (field.name === 'Voditel' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Водитель"';
                if (field.name === 'Telephone' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Телефон водителя"';
                if (field.name === 'cnt_number' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Контейнер №"'
                if (field.name === 'cnt_size' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Размер"'
                if (field.name === 'cnt_type' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Тип"'
                if (field.name === 'cnt_cargo' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Наименование груза"'
                if (field.name === 'cnt_weight' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Вес груза"'
                if (field.name === 'cnt_plomb' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Номер пломбы"'
                if (field.name === 'Station' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Станция назначения"'
                if (field.name === 'Email' && !field.value) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Email"'
            });
            if (!this.$get('kod_autocarrier')) errors += '<br />' + '&bull;&nbsp;не заполнено поле "Автоперевозчик"';


            formData.append('Date_oper', this.$get('date_oper').split('-').reverse().join('-'));
            let status = this.$get('status');
            if (status !== undefined){
                status = (status === 0) ? 1: status;
            } else {
                status = 0;
            }
            formData.append('Status', status);
            formData.append('sklad', this.$get('sklad'));
            this.$set('data', formData);
            this.errors = errors;
            if (errors) {
                this.errors = 'Ошибка при обработке данных заявки!' + errors;
                this.$parent && this.$broadcast('alert', {
                    name: this.name, type: 'form.error', view: true
                })
            } else {
                this.$parent && this.$broadcast('alert', {
                    name: this.name, type: 'form.error', view: false
                });
                store.$save(this);
                this.errors = ''
            }
            this.blockForm = false
        },
        // при закрытии окна возвратимся по истории назад и сбросим форму
        onClick(e) {
            e.preventDefault();
            this.$set('show', true);
            let from = this.$route.router._currentTransition.from.name || 'index';
            this.$route.router.go({name: from})
        },
    },

    watch: {

        // при получении данных о автоперевозчиках отсортируем
        // автоперевозчиков и создадим массив containers
        autoCarrierList: {
            handler(){
                let table = this.autoCarrierList.data.table;
                if (table) {
                    this.autocarriers = table.map(item => {
                        return {
                            value: item.kod,
                            text: item.name,
                        }
                    }).sort(compareText)
                }
            },
            deep: true,
        },
        slotsAutoList: {
            handler() {
                let table = this.slotsAutoList.data.table;
                if (table) {
                    this.slots = table.map(item => {
                        return item.name
                    })/*.sort(compareText)*/
                }
            },
            deep: true,
        },

        slot: {
            handler(value) {
                if (value){
                    this.$set('date_oper',value.split(' ')[0].replace('.','-').replace('.','-'));
                }
            },
            deep: false,
        },
        stationsList: {
            handler() {
                let table = this.stationsList.data.table;
                if ( table ) {
                    this.stations = table.map(  item => {
                        return {
                            value:item.code,
                            text: item.name+' - '+item.road,
                        }
                    }).sort(compareText)
                }

            },
            deep: true,
        },
        destinationsList: {
            handler() {
                let table = this.destinationsList.data.table;
                if ( table ) {
                    this.destinations = table.map(  item => {
                        return {
                            value:item.code,
                            text: item.text,
                        }
                    }).sort(compareText)
                }

            },
            deep: true,
        },
        kod_autocarrier:{
            handler(value) {
                if (value){
                   // this.getAutoList(value);
                }
            },
            deep: false,
        },
        autoList: {
            handler() {
                let table = this.autoList.data.table;
                if (table) {
                    this.autoLists = table.map(item => {
                        return item.number
                    }).sort(compareText)
                }
            },
            deep: true,
        },
    },

    events: {
        // при вызове заявки из таблицы контейнеров
        ['number:' + name]: function (data) {
            let {number: number, number: title} = data;
            let self = this;
            if (number !== ""){
                self.$set('number', number);
                self.$set('title', title);
                self.$set('sklad', data.sklad);
                self.$set('cnt_number', data.number);
                self.$set('cnt_size', data.size.id);
                self.$set('cnt_type', data.type.id);
                self.$set('cnt_cargo', data.cargo);
                self.$set('cnt_temp', data.temp);
                self.$set('cnt_weight', data.weight);
                self.$set('cnt_plomb', data.plomb);
                self.$set('voditel', data.voditel);
                self.$set('voditel_phone', data.telephone);
                self.$set('kod_autocarrier', data.autoCarrier);
                self.$set('station', data.station);
                self.$set('email', data.email ? data.email: store.$get('email'));
                self.$set('message', data.message);
                self.$set('status', data.status);
                let order_date = parseUnixTime(data.date, 'dateVs');
                if (self.date_oper !== order_date){
                    self.$set('date_oper', order_date);
                }
                setTimeout(function () {
                    if (self.slots) {
                        if (self.slots.indexOf(data.slot) === -1){
                            self.slots.unshift(data.slot);
                            self.slots.sort(compareText);
                        }
                    }
                    self.$set('slot', data.slot);
                    if (self.autoLists) {
                        if (self.autoLists.indexOf(data.transport) === -1){
                            self.autoLists.unshift(data.transport);
                            self.autoLists.sort(compareText);
                        }
                    }
                    self.$set('transport',data.transport );
                }, 4000);
                this.$set('buttonText', 'Изменить');
            }
        },

        // если есть ошибки, скроем поля формы
        'fetchData:error': function () {
            this.$set('blockForm', false);
            this.$set('show', true)
        },
        // если все ок, скроем поля формы
        'fetchData:ok': function () {
            this.$set('errors', '');
            this.$set('blockForm', true);
            this.$set('show', false);
            setTimeout(function () {
               window.location.reload();
            }, 200);
        },
    },

}




/** WEBPACK FOOTER **
 ** ./src/js/components/auto-import/component.js
 **/